import React, { useCallback, useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useState } from "react";
import ViewQuiltOutlinedIcon from '@mui/icons-material/ViewQuiltOutlined';
import Header from './Header';
import Drawer from './Drawer';
import { useData } from '../context/dataContext';
import { useAuth } from '../context/authContext';
import { useNavigate } from 'react-router-dom';

const DashboardLayout = () => {
    const { user } = useAuth();
    const { dataFirebase, brightness, loadData, setDataSelect } = useData()
    const [stateDrawer, setstateDrawer] = useState(false)
    const [itemsPanel, setItemsPanel] = useState(false)
    const [currentSection, setCurrentSection] = useState('');
    const location = useLocation();
    const { ident } = useParams();
    const navigate = useNavigate();

    useEffect(() => { setstateDrawer(false); }, [location]);

    const handlePanelSection = useCallback((state) => {
        if (!dataFirebase) return;

        if (ident) {
            // console.log("user ->", user);
            // console.log("Ident ->", ident);
            // console.log("dataFirebase ->", dataFirebase);
            const values = Object.values(dataFirebase);
            // console.log("values ->", values);
            const Masters = values.filter(val => val?.dataInfo).map(val => val.dataInfo)
            const selectedIndex = values.findIndex(item => item.dataInfo.Path === ident);
            const filterPath = selectedIndex !== -1 ? values[selectedIndex] : null;
            // console.warn(filterPath)
            if (selectedIndex !== -1 && filterPath) {
                const updatedDataFields = {
                    Maitenance: user?.Maintenance || false,
                    ...filterPath.dataFields,
                    resetPanel: {...filterPath.resetPanel},
                    IndexData: selectedIndex,
                    Masters,
                    Brightness: brightness,
                    brightnessDay: filterPath.brightnessPanel.Day,
                    brightnessNight: filterPath.brightnessPanel.Night,
                    connection: {
                        ID: ident,
                        name: filterPath.dataInfo.Name,
                        Online: filterPath.statePanel.InternetConect.State,
                        LastChange: filterPath.statePanel.LastChange,
                        Slaves: filterPath.statePanel.RS485_COM?.Fields ?? [],
                    }
                };
                setDataSelect(updatedDataFields)
                setCurrentSection(state ? filterPath.dataInfo.Name : "Conexion");
            } else {
                navigate('/Dashboard/Panel');
            }
        } else {
            setCurrentSection('Paneles');
        }
    }, [ident, dataFirebase, navigate, setDataSelect, brightness]);

    useEffect(() => {
        const currentPath = location.pathname;

        // if (currentPath.includes('Usuarios')) {
        //     setCurrentSection('Usuarios');
        // } else 
        if (currentPath.includes('Actividades')) {
            setCurrentSection('Actividades');
        } else if (currentPath.includes('Panel') || currentPath.includes('Conexion')) {
            handlePanelSection(currentPath.includes('Panel'));
        } else {
            setCurrentSection('Dashboard');
        }
    }, [location, handlePanelSection]);


    const handleDrawer = () => { setstateDrawer(!stateDrawer) }

    useEffect(() => {
        if (dataFirebase) {
            const dataRepresentation = Object.values(dataFirebase).filter(val => val?.dataInfo).map((item) => ({
                key: item.dataInfo.Name,
                icon: <ViewQuiltOutlinedIcon />,
                label: item.dataInfo.Name,
                route: item.dataInfo.Path
            }))
            setItemsPanel(dataRepresentation)
        }
    }, [dataFirebase, currentSection]);

    return (
        <>
            <div className="flex flex-col h-screen">
                <Header handleDrawer={handleDrawer} titulo={currentSection} />
                <Drawer
                    stateDrawer={stateDrawer}
                    handleDrawer={handleDrawer}
                    bodyItems={itemsPanel}
                    user={user}
                    dataFirebase={dataFirebase}
                    loadData={loadData}
                    currentSection={currentSection}
                    link={ident ?? null}
                >
                    <Outlet />
                </Drawer>
            </div>
        </>
    );
};

export default DashboardLayout;